// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import type { Model } from "../types.ts";

export const OPENCODE_GO_MODELS = {
	"deepseek-v4-flash": {
		id: "deepseek-v4-flash",
		name: "DeepSeek V4 Flash",
		api: "openai-completions",
		provider: "opencode-go",
		baseUrl: "https://opencode.ai/zen/go/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"maxTokensField":"max_tokens","requiresReasoningContentOnAssistantMessages":true,"thinkingFormat":"deepseek"},
		reasoning: true,
		thinkingLevelMap: {"minimal":null,"low":null,"medium":null,"high":"high","max":"max"},
		input: ["text"],
		cost: {
			input: 0.14,
			output: 0.28,
			cacheRead: 0.0028,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 384000,
	} satisfies Model<"openai-completions">,
	"deepseek-v4-pro": {
		id: "deepseek-v4-pro",
		name: "DeepSeek V4 Pro",
		api: "openai-completions",
		provider: "opencode-go",
		baseUrl: "https://opencode.ai/zen/go/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"maxTokensField":"max_tokens","requiresReasoningContentOnAssistantMessages":true,"thinkingFormat":"deepseek"},
		reasoning: true,
		thinkingLevelMap: {"minimal":null,"low":null,"medium":null,"high":"high","max":"max"},
		input: ["text"],
		cost: {
			input: 1.74,
			output: 3.48,
			cacheRead: 0.0145,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 384000,
	} satisfies Model<"openai-completions">,
	"glm-5.1": {
		id: "glm-5.1",
		name: "GLM-5.1",
		api: "openai-completions",
		provider: "opencode-go",
		baseUrl: "https://opencode.ai/zen/go/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"maxTokensField":"max_tokens"},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 1.4,
			output: 4.4,
			cacheRead: 0.26,
			cacheWrite: 0,
		},
		contextWindow: 202752,
		maxTokens: 32768,
	} satisfies Model<"openai-completions">,
	"glm-5.2": {
		id: "glm-5.2",
		name: "GLM-5.2",
		api: "openai-completions",
		provider: "opencode-go",
		baseUrl: "https://opencode.ai/zen/go/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"maxTokensField":"max_tokens"},
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":null,"low":null,"medium":null,"high":"high","max":"max"},
		input: ["text"],
		cost: {
			input: 1.4,
			output: 4.4,
			cacheRead: 0.26,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"grok-4.5": {
		id: "grok-4.5",
		name: "Grok 4.5",
		api: "openai-completions",
		provider: "opencode-go",
		baseUrl: "https://opencode.ai/zen/go/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"maxTokensField":"max_tokens"},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 6,
			cacheRead: 0.5,
			cacheWrite: 0,
		},
		contextWindow: 500000,
		maxTokens: 500000,
	} satisfies Model<"openai-completions">,
	"kimi-k2.6": {
		id: "kimi-k2.6",
		name: "Kimi K2.6",
		api: "openai-completions",
		provider: "opencode-go",
		baseUrl: "https://opencode.ai/zen/go/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"thinkingFormat":"deepseek","supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsLongCacheRetention":false},
		reasoning: true,
		thinkingLevelMap: {"minimal":null,"low":null,"medium":null},
		input: ["text", "image"],
		cost: {
			input: 0.95,
			output: 4,
			cacheRead: 0.16,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 65536,
	} satisfies Model<"openai-completions">,
	"kimi-k2.7-code": {
		id: "kimi-k2.7-code",
		name: "Kimi K2.7 Code",
		api: "openai-completions",
		provider: "opencode-go",
		baseUrl: "https://opencode.ai/zen/go/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"maxTokensField":"max_tokens"},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.95,
			output: 4,
			cacheRead: 0.19,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 262144,
	} satisfies Model<"openai-completions">,
	"kimi-k3": {
		id: "kimi-k3",
		name: "Kimi K3",
		api: "openai-completions",
		provider: "opencode-go",
		baseUrl: "https://opencode.ai/zen/go/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"maxTokensField":"max_tokens"},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 3,
			output: 15,
			cacheRead: 0.3,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"mimo-v2.5": {
		id: "mimo-v2.5",
		name: "MiMo V2.5",
		api: "openai-completions",
		provider: "opencode-go",
		baseUrl: "https://opencode.ai/zen/go/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"maxTokensField":"max_tokens"},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.14,
			output: 0.28,
			cacheRead: 0.0028,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"openai-completions">,
	"mimo-v2.5-pro": {
		id: "mimo-v2.5-pro",
		name: "MiMo V2.5 Pro",
		api: "openai-completions",
		provider: "opencode-go",
		baseUrl: "https://opencode.ai/zen/go/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"maxTokensField":"max_tokens"},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 1.74,
			output: 3.48,
			cacheRead: 0.0145,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 128000,
	} satisfies Model<"openai-completions">,
	"minimax-m2.7": {
		id: "minimax-m2.7",
		name: "MiniMax-M2.7",
		api: "openai-completions",
		provider: "opencode-go",
		baseUrl: "https://opencode.ai/zen/go/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"maxTokensField":"max_tokens"},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.3,
			output: 1.2,
			cacheRead: 0.06,
			cacheWrite: 0,
		},
		contextWindow: 204800,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"minimax-m3": {
		id: "minimax-m3",
		name: "MiniMax-M3",
		api: "anthropic-messages",
		provider: "opencode-go",
		baseUrl: "https://opencode.ai/zen/go",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.3,
			output: 1.2,
			cacheRead: 0.06,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 131072,
	} satisfies Model<"anthropic-messages">,
	"qwen3.6-plus": {
		id: "qwen3.6-plus",
		name: "Qwen3.6 Plus",
		api: "openai-completions",
		provider: "opencode-go",
		baseUrl: "https://opencode.ai/zen/go/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"thinkingFormat":"qwen","maxTokensField":"max_tokens"},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.5,
			output: 3,
			cacheRead: 0.05,
			cacheWrite: 0.625,
		},
		contextWindow: 1000000,
		maxTokens: 65536,
	} satisfies Model<"openai-completions">,
	"qwen3.7-max": {
		id: "qwen3.7-max",
		name: "Qwen3.7 Max",
		api: "anthropic-messages",
		provider: "opencode-go",
		baseUrl: "https://opencode.ai/zen/go",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 2.5,
			output: 7.5,
			cacheRead: 0.5,
			cacheWrite: 3.125,
		},
		contextWindow: 1000000,
		maxTokens: 65536,
	} satisfies Model<"anthropic-messages">,
	"qwen3.7-plus": {
		id: "qwen3.7-plus",
		name: "Qwen3.7 Plus",
		api: "anthropic-messages",
		provider: "opencode-go",
		baseUrl: "https://opencode.ai/zen/go",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.4,
			output: 1.6,
			cacheRead: 0.04,
			cacheWrite: 0.5,
		},
		contextWindow: 1000000,
		maxTokens: 65536,
	} satisfies Model<"anthropic-messages">,
} as const;
